import { Button, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon, ConfirmationDialog } from '@tom-ui/ui'
import { useState } from 'react'

interface Props {
  onConfirm: () => void
}
export const OperationalEquipmentClearAll = ({ onConfirm }: Props) => {
  const { t } = useTranslate()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant='contained'
        color='inherit'
        endIcon={<BinIcon />}
        onClick={() => setOpen(true)}
        data-cy='operational-equipment-clear-all-btn'
      >
        {t('clearAll', 'Clear all')}
      </Button>

      <ConfirmationDialog
        open={open}
        title={t('confirmation', 'Confirmation')}
        primaryActionDataCy='operational-equipment-confirm-clean-all-btn'
        primaryActionText={t('yes', 'Yes')}
        closeLabel={t('cancel', 'Cancel')}
        onConfirm={() => {
          onConfirm()
          setOpen(false)
        }}
        onClose={() => setOpen(false)}
      >
        <Stack gap={2}>
          <Typography variant='subtitle2' color='secondary'>
            {t(
              'byConfirmingYouWillClearAllInformationRelatedToTheAssignments',
              'By confirming, you will clear all information related to the assignments.',
            )}
          </Typography>

          <Typography variant='subtitle2' color='secondary'>
            {t('doYouWantToProceed', 'Do you want to proceed?')}
          </Typography>
        </Stack>
      </ConfirmationDialog>
    </>
  )
}
